export const SCHEDULE_GET = 'scheduleGet'
export const SCHEDULES_GET = 'schedulesGet'
